import _taggedTemplateLiteral from "@babel/runtime/helpers/esm/taggedTemplateLiteral";
var _templateObject;
import React from 'react';
import gql from 'graphql-tag';
import orderBy from 'lodash/orderBy';
import { Icon, Input, Message } from 'semantic-ui-react';
import { AuthClient, Popup, handleFocusStolen, MenuButton, getProfileAvatar } from '@emyw/core-lib';
import UpdatePinForm from '../UpdatePinForm';
import ButtonLink from '../ButtonLink';
const validateProfilePinMutation = gql(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    mutation ($profileId: Int!, $pin: String!) {\n        validatePin: validateProfilePin (profileId: $profileId, pin: $pin) {\n            ok\n            errors {\n                path\n                message\n            }\n        }\n    }\n"])));
class ChooseProfileForm extends React.Component {
  constructor() {
    super(...arguments);
    this.state = {
      isSubmitting: false,
      forgotPinModalOpen: false,
      errors: null
    };
    this.handlePinEntry = (e, data, profile) => {
      const {
        user,
        onSelectProfile,
        closeForm
      } = this.props;
      // if we see that they have entered the right number of values, attempt to validate the pin
      if ((data.value || '').length > 3) {
        AuthClient.mutate({
          mutation: validateProfilePinMutation,
          variables: {
            profileId: profile.id,
            pin: data.value
          }
        }).then(res => {
          log.trace(res);
          const {
            ok,
            errors
          } = res.data.validatePin;
          if (ok) {
            if (onSelectProfile) onSelectProfile({
              user,
              profile
            });else log.warn('onSelectProfile prop required but not provided');
            // this.setState({ isSubmitting: false, errors: null });
            closeForm();
          } else {
            this.setState({
              isSubmitting: false,
              errors: {
                profileId: profile.id,
                message: errors[0].message
              }
            });
          }
        }).catch(error => {
          log.trace(error.message);
          this.setState({
            isSubmitting: false,
            errors: {
              profileId: profile.id,
              message: error.message
            }
          });
        });
      }
    };
    this.handleSelectOnlyProfile = () => {
      const {
        user,
        onSelectProfile,
        closeForm
      } = this.props;
      const profile = user.Profiles[0];
      log.trace('auto-selecting only profile:', profile);
      if (onSelectProfile) onSelectProfile({
        user,
        profile
      });else log.warn('onSelectProfile prop required but not provided');
      closeForm();
    };
    this.handleForgotPin = () => this.setState({
      forgotPinModalOpen: true
    });
    /* Prevent autofill */
    this.handlePinRef = ref => {
      if (!ref) return;
      this.pinInputRef = ref.inputRef.current || ref.inputRef;
      /* eslint-disable-next-line no-param-reassign */
      if (this.pinInputRef) this.pinInputRef.onblur = handleFocusStolen;
      // if (this.pinInputRef) this.pinInputRef.addEventListener('blur', handleFocusStolen);
    };
    this.removePinEventListeners = () => {
      /* eslint-disable-next-line no-param-reassign */
      if (this.pinInputRef) this.pinInputRef.onblur = null;
      // if (this.pinInputRef) this.pinInputRef.removeEventListener('blur', handleFocusStolen);
    };
  }
  componentDidMount() {
    const {
      Profiles
    } = this.props.user;
    if ((Profiles || []).length === 1 && !(Profiles[0] || {}).securedByPIN) {
      this.handleSelectOnlyProfile();
    }
  }
  componentWillUnmount() {
    this.removePinEventListeners();
  }
  render() {
    const {
      user,
      onSelectProfile,
      closeForm,
      mountNode
    } = this.props;
    const {
      isSubmitting,
      forgotPinModalOpen,
      errors
    } = this.state;

    /* Prevent long or techy error messages from being displayed: */
    let errorMessage = '';
    if ((errors || {}).message) {
      if (errors.message.match('Invalid profile PIN')) {
        errorMessage = 'Invalid PIN';
      } else {
        errorMessage = 'Unknown Error';
        log.warn('Pin form error:', errors.message);
      }
    }
    log.trace('user:', user);
    const orderedProfiles = orderBy(user.Profiles, ['id'], ['asc']);
    // log.trace('orderedProfiles:', orderedProfiles);

    return /*#__PURE__*/React.createElement("div", {
      className: "enjoyProfileLogin"
    }, /*#__PURE__*/React.createElement("div", {
      className: "profileList_menu"
    }, orderedProfiles.map((profile, index) => /*#__PURE__*/React.createElement(React.Fragment, {
      key: index.toString()
    }, /*#__PURE__*/React.createElement(MenuButton, {
      className: "profileSelectable",
      fluid: true,
      onClick: () => {
        if (!profile.securedByPIN) {
          log.trace('a profile was selected', profile);
          if (onSelectProfile) onSelectProfile({
            user,
            profile
          });else log.warn('onSelectProfile prop required but not provided');
          closeForm();
        }
      }
    }, /*#__PURE__*/React.createElement("div", {
      className: "profileBadge"
    }, /*#__PURE__*/React.createElement("div", {
      className: "avatar_wrapper"
    }, /*#__PURE__*/React.createElement("div", {
      className: "profile_avatar_button menuButton"
    }, getProfileAvatar({
      profile,
      className: 'menu',
      avatarFloat: 'left',
      iconSize: 'large'
    }))), /*#__PURE__*/React.createElement("div", {
      className: "profile_avatar_name menuCol"
    }, /*#__PURE__*/React.createElement("strong", null, profile.name))), profile.securedByPIN && /*#__PURE__*/React.createElement("div", {
      className: "profileSelectPin"
    }, (errors || {}).message && (errors || {}).profileId === profile.id && /*#__PURE__*/React.createElement(Message, {
      size: "mini",
      error: true
    }, errorMessage), /*#__PURE__*/React.createElement(Input, {
      ref: this.handlePinRef,
      style: {
        minWidth: '9em',
        maxWidth: '9em'
      },
      icon: true,
      iconPosition: "left",
      type: "password",
      placeholder: "PIN",
      maxLength: 4,
      disabled: isSubmitting,
      loading: isSubmitting,
      "data-lpignore": true,
      onChange: (e, data) => this.handlePinEntry(e, data, profile)
    }, /*#__PURE__*/React.createElement(Icon, {
      name: "lock"
    }), /*#__PURE__*/React.createElement("input", {
      "data-lpignore": true,
      autoComplete: "new-password"
    }), /*#__PURE__*/React.createElement("i", {
      className: "pinInputHelper"
    }, /*#__PURE__*/React.createElement(Popup, {
      className: "pinHelperPopup",
      position: "top right",
      mountNode: mountNode,
      content: /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("p", null, "Please enter your profile or account level PIN."), /*#__PURE__*/React.createElement("p", null, "Can't remember it? Click", ' ', /*#__PURE__*/React.createElement(ButtonLink, {
        as: "span",
        onClick: this.handleForgotPin
      }, "here"), ' ', " ", "to reset your account PIN.")),
      trigger: /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement(Icon, {
        name: "help circle",
        link: true
      }))
    }))))), /*#__PURE__*/React.createElement(UpdatePinForm, {
      open: forgotPinModalOpen,
      onExit: () => this.setState({
        forgotPinModalOpen: false
      }),
      user: user,
      forgotPinMode: true,
      mountNode: mountNode || undefined
    })))));
  }
}
ChooseProfileForm.defaultProps = {
  closeForm: () => {},
  mountNode: document.body // Default to body to avoid bounding overflow conditions (pin input popup will be hidden if this null)
};
export default ChooseProfileForm;